<div class="container">

  <div class="title-container">
    <div class="vox-heading-3" translate>connectivity.edit-documents-modal.title <span>{{entry?.brand}} {{entry?.model}}</span></div>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <i class="icon-small-close"></i>
    </button>
  </div>

  <div class="documents-table vox-table">
    <table>
      <tbody>
        <ng-container *ngIf="entry?.links.length > 0">
          <tr *ngFor="let document of entry?.links; let idx = index">
            <ng-container *ngIf="loadingDelete !== idx">
              <td>{{document.name}}</td>
              <td>
                <button class="vox-btn delete-document" (click)="onDeleteDocument(document.id, idx)">
                  <i class="icon-small-delete"></i>
                </button>
              </td>
            </ng-container>
            <ng-container style="width: 100%;" *ngIf="loadingDelete === idx">
              <td class="loader">
                <ngx-skeleton-loader count="1" [theme]="{'height': '16px', 'width': '100%', 'margin': '0'}"></ngx-skeleton-loader>
              </td>
              <td class="loader center">
                <ngx-skeleton-loader count="1" [theme]="{'height': '16px', 'width': '16px', 'margin': '0'}"></ngx-skeleton-loader>
              </td>
            </ng-container>
          </tr>
        </ng-container>
        <ng-container *ngIf="entry?.links.length === 0">
          <tr>
            <td class="full" translate>
              connectivity.edit-documents-modal.no-documents
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div class="add-document">
    <div class="vox-heading-5" translate>connectivity.edit-documents-modal.form.title</div>
    <div class="file-upload">
      <label for="name" class="vox-label" translate>connectivity.edit-documents-modal.form.file.label</label>

      <div class="vox-inline-message vox-inline-message_light-grey">
        <div>
          <i class="icon-small-info"></i>
          <span [innerHTML]="'connectivity.edit-documents-modal.form.file.disclaimer' | translate"></span>
        </div>
      </div>
      <button type="button"
        class="vox-btn vox-btn-secondary file-upload-button"
        (click)="fileupload.click()"
        translate>
        connectivity.edit-documents-modal.action.select-file <i class="fas fa-file-upload"></i>
      </button>
      <input type="file" (change)="onFileUpload($event)" hidden #fileupload>
      <label class="file-upload-name">{{form.value?.file?.file?.name}}</label>
    </div>
    <form class="add-document-form" [formGroup]="form">
      <div class="vox-input-group vox-input-group_dense"
        [ngClass]="{'vox-input-group_invalid': form.controls.name?.invalid && (form.controls.name?.dirty || form.controls.name?.touched)}">
        <label for="name" class="vox-label" translate>connectivity.edit-documents-modal.form.name.label</label>
        <input class="vox-text-field document-name" formControlName="name" id="name" type="text">
        <span class="vox-input-group__error-message" translate>connectivity.errors.required</span>
      </div>
      <div class="vox-input-group vox-input-group_dense"
        [ngClass]="{'vox-input-group_invalid': form.controls.description?.invalid && (form.controls.description?.dirty || form.controls.description?.touched)}">
        <label for="description" class="vox-label" translate>connectivity.edit-documents-modal.form.description.label</label>
        <textarea class="vox-text-field document-description" formControlName="description" id="description" rows="5"></textarea>
        <span class="vox-input-group__error-message" translate>connectivity.errors.required</span>
      </div>
    </form>
    <div class="action-container">
      <button type="button" class="vox-btn vox-btn-secondary" (click)="onAddDocument()" [ladda]="loadingRequest" data-spinner-size="40" data-spinner-color="black" data-style="zoom-in" [disabled]="form.invalid">{{'connectivity.edit-documents-modal.action.add-file' | translate}}</button>
    </div>
  </div>
</div>